module.exports = __webpack_public_path__ + "static/media/icomoon.34ffea27.ttf";